import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './ProductLinker.scss';

export interface ProductLinkerProps {
    symKar?: string;
    unit?: string;
    path?: string;
    style?: React.CSSProperties;
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
}

const ProductLinker = ({ symKar, unit, path, style, children, className, onClick }: ProductLinkerProps) => {
    const history = useHistory();
    const location = useLocation();
    const isInvalidLinker = !path && (!unit || !symKar);
    const redirectToProductPageOnClick = () => {
        if (isInvalidLinker) return;
        if (onClick) onClick();
        const params = new URLSearchParams();
        if (path) params.set('path', path);
        if (symKar) params.set('symkar', symKar);
        if (unit) params.set('unit', unit);

        history.push(`${location.pathname}?${params.toString()}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div
            className={[(isInvalidLinker ? '' : 'linker'), className].filter(Boolean).join(' ')}
            style={{ ...style }}
            onClick={redirectToProductPageOnClick}
        >
            {children}
        </div>
    );
};

export default ProductLinker;
